import { createUseStyles } from "react-jss";
import { mediaQueries } from "../../constants/mediaQueries";

export const LoginContainerStyle = createUseStyles((theme: any) => ({
    container: {
        height: "100%",
        display: "flex",
        width: "100%",
        flexDirection: "column",
        alignItems: "center",
        gap: "var(--gaps-sizes-xl)",
        backgroundColor: "var(--ion-color-danger-contrast)",
    },
    message: {
        padding: "var(--padding-sizes-base)",
        textAlign: "center",
    },
    form: {
        padding: "var(--padding-sizes-base)",
        display: "flex",
        flexDirection: "column",
        alignContent: "center",
        alignItems: "center",
        gap: "var(--gaps-sizes-xxl)",
        width: "100%",
    },
    row: {
        display: "flex",
        gap: "var(--gaps-sizes-sm)",
        alignContent: "end",
        alignItems: "end",
        height: "2rem",
        width: "50vw",
        maxWidth: 400,
        [mediaQueries.MOBILE]: {
            width: "90vw",
        },
    },
    signUpBtn: {
        marginTop: "var(--margin-sizes-xl)",
    },
    icon: {
        width: "auto",
        maxWidth: "1.5rem",
    },
    imageContent: {
        display: "flex",
        justifyContent: "center",
    },
    image: {
        padding: "var(--padding-sizes-sm)",
        display: "block",
        width: "15vw",
        maxWidth: 250,
        objectFit: "inherit",
        objectPosition: "inherit",
        [mediaQueries.LAPTOP]: {
            width: "15vw",
        },
        [mediaQueries.TABLET]: {
            width: 125,
        },
        [mediaQueries.MOBILE]: {
            width: 125,
        },
    },
    section: {
        display: "flex",
        flexDirection: "column",
        gap: "var(--gaps-sizes-sm)",
    },
}));
